import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { AuthHeaders } from '../../../models/auth-headers';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { SectionName } from '../models/section-name';
import { weatherAlertsSchema } from '../schemas/weather-alerts.schema';
import { tripManagementSettingsEnvironment } from '../trip-management-settings-environment';

/**
 * Retrieves the named configuration section or all sections if name is omitted
 * @param sectionName Optional. When provided, returns data for the named section. Otherwise returns all sections
 */
export function getConfigurationSectionName(
  this: unknown,
  sectionName?: SectionName
) {
  return fromFetch(
    new Request(
      tripManagementSettingsEnvironment
        .resolve(this)
        .configurationSectionNameUrl(sectionName),
      {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...new AuthHeaders(),
        },
      }
    )
  ).pipe(
    // Note: I only had time to flesh out the schema for weatherAlerts.
    // The other sections should be added here when needed.
    selectData(z.object({ weatherAlerts: weatherAlertsSchema.optional() }))
  );
}
